// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as GraphQLQueries$LiveRoom from "./GraphQLQueries.bs.js";

function getUserIdSummary(maybeToken) {
  return Curry._2(GraphQLQueries$LiveRoom.Clientapi.Queries.UserIdSummary.Query.queryAndParseFuture, maybeToken, undefined);
}

export {
  getUserIdSummary ,
}
/* GraphQLQueries-LiveRoom Not a pure module */
